export default {
	API_URL: 'https://api-ottonelli.infinitum-ti.com/api',
	OAPI_URL: 'https://api-ottonelli.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2379/api',
	// OAPI_URL: 'http://localhost:2379/oapi',
}
